import React from 'react';
import { View } from 'react-native';
import { useColors } from '../theme';
import { T } from './Text';

export function BarTrack({ fraction }: { fraction: number }) {
  const colors = useColors();
  const pct = Math.max(0, Math.min(1, fraction)) * 100;
  return (
    <View
      style={{
        height: 9,
        backgroundColor: colors.surface2,
        borderRadius: 6,
        overflow: 'hidden',
      }}
    >
      {/* Flat gold instead of the CSS gradient — one fill reads the same at 9px. */}
      <View style={{ width: `${pct}%`, height: '100%', backgroundColor: colors.gold }} />
    </View>
  );
}

export function BarRow({
  name,
  fraction,
  count,
}: {
  name: string;
  fraction: number;
  count: number;
}) {
  const colors = useColors();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingVertical: 7,
      }}
    >
      <T size={12.5} color={colors.textDim} numberOfLines={1} style={{ width: 150 }}>
        {name}
      </T>
      <View style={{ flex: 1 }}>
        <BarTrack fraction={fraction} />
      </View>
      <T size={11.5} color={colors.textFaint} style={{ width: 46, textAlign: 'right' }}>
        {count}×
      </T>
    </View>
  );
}
